import styled from 'styled-components';
import { SkeletonBase } from '../../../UIelements/Skeleton/styles';

export const Card = styled.div`
  box-shadow: 0 0 0.7em ${({ theme }) => theme.colors.boxShadow};
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SectionTitle = styled(SkeletonBase)`
  height: 24px;
  width: 35%;
`;
